import { GovIcon } from '@gov-design-system-ce/react/gov-icon';
import type { IconProps } from './types';

export const Icon = (props: IconProps) => <GovIcon {...props} />;
